import { COLOR_SCHEMES, RANGEGROUP_TYPES } from "./constants";

export const demoBoard = ["7h", "As", "8s"];

export const demoSubranges = RANGEGROUP_TYPES.default.subranges;

export const demoColorScheme = COLOR_SCHEMES.default;
